/* eslint-disable no-underscore-dangle */
import lod_ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MDBox from "components/Basics/MDBox";
import FormAction from "redux-react/actions/formAction";
import Message from "../Message";
import MDButton from "components/Basics/MDButton";
import MDTypography from "components/Basics/MDTypography";
import { CircularProgress, LinearProgress } from "@mui/material";
import { useResourceActions } from "hooks/useResourceActions";
import { socket } from "redux-react/middleware/ws";
import { t } from "i18next";

const ConversationTab = ({ phoneCall, resource }) => {
	const { updateResource, performAction } = useResourceActions();

	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [conversation, setConversation] = useState(null);

	const conversationHasMessages =
		!lod_.isEmpty(conversation?.messages) && !lod_.isNil(conversation?.messages);

	const startTranscription = () => {
		// 1- Set status to "running"
		updateResource(
			resource,
			conversation._id,
			{
				transcriptionStatus: "running"
			},
			() => {
				setConversation(prev => ({
					...prev,
					transcriptionStatus: "running"
				}));
			}
		);
		// 2- Call the hook
		performAction(
			{
				resourceCode: "conversationLight",
				items: [conversation._id],
				action: {
					type: "hook",
					code: "phoneCallTranscription",
					config: {
						url: phoneCall.url
					}
				}
			},
			() => {}
		);
	};

	const getTranscriptionStatus = () => {
		switch (conversation?.transcriptionStatus) {
			case "running": {
				return (
					<MDBox>
						<MDTypography variant="h6" fontWeight="medium">
							{t("FORMS.RESOURCE.PHONECALL.transcribeRunningTitle")}
						</MDTypography>
						<MDTypography variant="body2" color="text">
							{t("FORMS.RESOURCE.PHONECALL.transcribeRunningDescription")}
						</MDTypography>

						<MDBox sx={{ mt: 2, overflow: "hidden" }}>
							<LinearProgress color="info" />
						</MDBox>
					</MDBox>
				);
			}
			default: {
				return (
					<MDBox>
						<MDTypography variant="h6" fontWeight="medium">
							{t("FORMS.RESOURCE.PHONECALL.noTranscriptionTitle")}
						</MDTypography>
						<MDTypography variant="body2" color="text">
							{t("FORMS.RESOURCE.PHONECALL.noTranscriptionDescription")}
						</MDTypography>
						<MDTypography variant="body2" color="text">
							{t("FORMS.RESOURCE.PHONECALL.noTranscriptionCallToButton")}
						</MDTypography>
						<MDButton color="info" sx={{ mt: 5 }} onClick={startTranscription}>
							{t("FORMS.RESOURCE.PHONECALL.startTranscription")}
						</MDButton>
					</MDBox>
				);
			}
		}
	};

	useEffect(() => {
		const fID = phoneCall?.fID;
		if (fID) {
			dispatch(
				FormAction.getItemsFromCollection(
					resource,
					{
						query: {
							fID,
							active: { $in: [true, false, null] }
						}
					},
					res => {
						if (res.items.length > 0) {
							setConversation(res.items[0]);
						}
						setLoading(false);
					}
				)
			);
		} else {
			setLoading(false);
		}
	}, [phoneCall?.fID]);

	/**
	 * Result when messages are transcribed
	 * @param {object} data the data received from the socket
	 */
	const updateConversation = ({ action, data }) => {
		const conversationID = lod_.get(data, "_id", null);

		if (
			!lod_.isNil(conversationID) &&
			!lod_.isNil(conversation?._id) &&
			conversationID === conversation._id
		) {
			setConversation(prev => ({
				...prev,
				...data
			}));
		}
	};

	useEffect(() => {
		socket.on(`UPDATE_RESOURCE_DATAS_${resource}`, updateConversation);

		return () => {
			socket.off(`UPDATE_RESOURCE_DATAS_${resource}`, updateConversation);
		};
	}, [resource, conversation?._id]);

	if (loading) {
		return (
			<MDBox p={2} textAlign="center">
				<CircularProgress size={24} color="info" />
			</MDBox>
		);
	}

	if (lod_.isNil(conversation)) {
		return (
			<MDBox p={2} textAlign="center">
				{t("FORMS.RESOURCE.PHONECALL.noConversationAvailable")}
			</MDBox>
		);
	}

	return (
		<MDBox
			mt={1}
			style={{
				overflowY: "auto"
			}}
		>
			{!conversationHasMessages && <MDBox m={2}>{getTranscriptionStatus()}</MDBox>}

			{conversationHasMessages && (
				<MDBox
					borderRadius="md"
					p={1}
					style={{
						backgroundColor: "rgb(236 236 236)",
						overflowY: "auto"
					}}
				>
					{conversation.messages.map((message, index) => (
						<Message key={index} message={message} />
					))}
				</MDBox>
			)}
		</MDBox>
	);
};

export default ConversationTab;
